import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SectorInsight {
  sector: string;
  growth_rate: number;
  description: string;
  trend_direction: 'up' | 'down' | 'stable';
  volatility?: number;
}

export interface TrendingOccupation {
  occupation_code: string;
  title: string;
  location: string;
  growth_5yr: number;
  employment: number;
  avg_salary: number;
}

export interface MarketInsights {
  sector_insights: SectorInsight[];
  trending_occupations: TrendingOccupation[];
  market_metadata: {
    data_as_of: string;
    total_occupations_analyzed: number;
    coverage_period: string;
    source_year: number;
  };
}

export const useMarketInsights = () => {
  return useQuery({
    queryKey: ['market-insights'],
    queryFn: async (): Promise<MarketInsights> => {
      console.log('Fetching market insights...');
      
      const { data, error } = await supabase.functions.invoke('api-market-insights');
      
      if (error) {
        console.error('Market insights error:', error);
        throw new Error(error.message || 'Failed to fetch market insights');
      }

      if (!data) {
        throw new Error('No market insights data received');
      }

      console.log('Market insights data received:', data);
      return data;
    },
    staleTime: 6 * 60 * 60 * 1000, // 6 hours
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};